// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ================= MEIC PAGE ================= */

.meicPage {
  min-height: 100%;
  padding: 22px;
  color: #f4f4f4;
  background:
    radial-gradient(circle at top left, rgba(177, 136, 0, 0.12), transparent 34%),
    #050505;
  box-sizing: border-box;
}

/* ================= SHARED CARD BASE ================= */

.meicHeroContent,
.meicSummaryCard,
.meicStatCard,
.meicPanel,
.meicInsightCard,
.meicTablePanel {
  border: 1px solid rgba(177, 136, 0, 0.28);
  border-radius: 18px;
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.035), rgba(255, 255, 255, 0.015)),
    #0b0b0b;
  box-shadow: 0 18px 42px rgba(0, 0, 0, 0.35);
  box-sizing: border-box;
}

.meicHeroContent,
.meicSummaryCard,
.meicStatCard,
.meicPanel,
.meicInsightCard,
.meicTablePanel {
  padding: 20px;
}

.meicEyebrow,
.meicSectionEyebrow,
.meicStatLabel,
.meicSummaryLabel,
.meicHistoryTable th {
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.meicEyebrow,
.meicSectionEyebrow {
  color: #d8b44c;
  font-size: 0.72rem;
}

.meicStatLabel,
.meicSummaryLabel {
  color: rgba(244, 244, 244, 0.52);
  font-size: 0.7rem;
}

/* ================= HERO ================= */

.meicHero {
  display: grid;
  grid-template-columns: minmax(0, 1.35fr) minmax(420px, 0.85fr);
  gap: 18px;
  align-items: stretch;
  margin-bottom: 18px;
}

.meicHeroContent,
.meicSummaryCard {
  height: 100%;
  min-width: 0;
}

.meicHeroContent {
  padding: 24px 28px;
  position: relative;
  overflow: hidden;
}

.meicEyebrow {
  display: inline-flex;
  width: fit-content;
  letter-spacing: 0.11em;
}

.meicHeroContent h1 {
  margin: 10px 0 0;
  color: #ffffff;
  font-size: clamp(2.4rem, 4vw, 4rem);
  line-height: 0.95;
  letter-spacing: 0.02em;
}

.meicHeroContent h2 {
  margin: 8px 0 0;
  color: #b18800;
  font-size: clamp(1.2rem, 2vw, 1.7rem);
  font-weight: 800;
}

.meicHeroContent p {
  max-width: 900px;
  margin: 14px 0 0;
  color: rgba(244, 244, 244, 0.74);
  font-size: 0.96rem;
  line-height: 1.58;
}

/* ================= HERO ACTIONS ================= */
/* ================= HERO ACTIONS ================= */

.meicHeroActions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 18px;
}

.meicPrimaryButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  padding: 11px 15px;
  border: 1px solid rgba(177, 136, 0, 0.52);
  border-radius: 12px;
  color: #f4d06f;
  background:
    linear-gradient(145deg, rgba(177, 136, 0, 0.18), rgba(255, 255, 255, 0.035)),
    rgba(177, 136, 0, 0.08);
  font-size: 0.82rem;
  font-weight: 900;
  text-decoration: none;
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.28);
  transition:
    background 160ms ease,
    border-color 160ms ease,
    transform 160ms ease;
}

.meicPrimaryButton:hover {
  border-color: rgba(216, 180, 76, 0.78);
  background:
    linear-gradient(145deg, rgba(177, 136, 0, 0.26), rgba(255, 255, 255, 0.05)),
    rgba(177, 136, 0, 0.12);
  transform: translateY(-1px);
}
/* ================= SUMMARY CARD ================= */

.meicSummaryCard {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.meicSummaryStatus {
  margin: 8px 0 0;
  color: #ffffff;
  font-size: clamp(1.2rem, 2vw, 1.7rem);
  line-height: 1.1;
  font-weight: 800;
}

.meicSummaryCard p {
  margin: 14px 0 0;
  color: rgba(244, 244, 244, 0.68);
  font-size: 0.9rem;
  line-height: 1.55;
}

.meicSummaryGrid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-top: 18px;
}

.meicSummaryMetric {
  min-width: 0;
  padding: 14px;
  border: 1px solid rgba(255, 255, 255, 0.075);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.035);
  box-sizing: border-box;
}

.meicSummaryMetric strong {
  display: block;
  margin-top: 9px;
  color: #ffffff;
  font-size: 1.25rem;
  line-height: 1;
  font-weight: 800;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.meicSummaryMetric small {
  display: block;
  margin-top: 8px;
  color: rgba(244, 244, 244, 0.48);
  font-size: 0.74rem;
  line-height: 1.25;
}

/* ================= TOP KPI STRIP ================= */

.meicStatsGrid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 18px;
}

.meicStatCard {
  min-width: 0;
  padding: 16px;
  border: 1px solid rgba(255, 255, 255, 0.075);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.035);
}

.meicStatLabel {
  display: block;
}

.meicStatValue {
  display: block;
  margin-top: 10px;
  color: #ffffff;
  font-size: 1.45rem;
  line-height: 1;
  font-weight: 800;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.meicStatSubtext {
  display: block;
  margin-top: 8px;
  color: rgba(244, 244, 244, 0.48);
  font-size: 0.75rem;
  line-height: 1.25;
}

/* ================= TWO COLUMN CONTENT ================= */

.meicTwoColumnLayout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(360px, 0.72fr);
  gap: 18px;
  align-items: stretch;
  margin-bottom: 18px;
}

.meicLeftColumn {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  min-width: 0;
}

.meicRightColumn {
  min-width: 0;
}

/* ================= INSIGHT CARDS ================= */

.meicInsightCard {
  min-width: 0;
  padding: 16px;
  border: 1px solid rgba(255, 255, 255, 0.075);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.035);
}

.meicInsightCard h3 {
  margin: 6px 0 0;
  color: #ffffff;
  font-size: 1.08rem;
  line-height: 1.2;
  letter-spacing: 0;
}

.meicInsightCard p {
  margin: 10px 0 0;
  color: rgba(244, 244, 244, 0.68);
  font-size: 0.88rem;
  line-height: 1.5;
}

/* ================= PANEL HEADER ================= */

.meicPanel {
  min-width: 0;
  overflow: hidden;
  margin-bottom: 18px;
}

.meicPanelHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
}

.meicPanelHeader h2,
.meicPanelHeader h3 {
  margin: 6px 0 0;
  color: #ffffff;
  font-size: 1.15rem;
  line-height: 1.2;
  letter-spacing: 0;
}

.meicPanelHeader p {
  margin: 6px 0 0;
  color: rgba(244, 244, 244, 0.58);
  font-size: 0.84rem;
  line-height: 1.4;
}

.meicPanelHeaderCompact {
  margin-bottom: 12px;
}

.meicPanelHeaderCompact h2 {
  margin: 5px 0 4px;
  font-size: 1.05rem;
  line-height: 1.2;
}

.meicPanelHeaderCompact p {
  margin: 0;
  max-width: 360px;
  color: rgba(244, 244, 244, 0.58);
  font-size: 0.78rem;
  line-height: 1.35;
}

/* ================= RIGHT SIDE RECENT RESULTS TABLE ================= */

.meicRecentSessionsPanel {
  height: 100%;
  min-width: 0;
  padding: 16px;
  overflow: hidden;
}

.meicTableWrap {
  width: 100%;
  overflow-x: auto;
}

.meicHistoryTable {
  width: 100%;
  min-width: 320px;
  border-collapse: collapse;
  table-layout: fixed;
}

.meicHistoryTable th {
  padding: 9px 8px;
  color: rgba(244, 244, 244, 0.52);
  font-size: 0.68rem;
  text-align: left;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.meicHistoryTable td {
  padding: 10px 8px;
  color: rgba(244, 244, 244, 0.82);
  font-size: 0.8rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.055);
  vertical-align: middle;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.meicHistoryTable tbody tr:hover {
  background: rgba(177, 136, 0, 0.055);
}

.meicHistoryTableCompact th,
.meicHistoryTableCompact td {
  width: 33.333%;
}

.meicHistoryTableCompact th:nth-child(2),
.meicHistoryTableCompact th:nth-child(3),
.meicHistoryTableCompact td:nth-child(2),
.meicHistoryTableCompact td:nth-child(3) {
  text-align: right;
}

.meicHistoryTableCompact tbody tr:last-child td {
  border-bottom: none;
}

/* ================= STRUCTURE GRID ================= */

.meicStructureGrid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.meicStructureGrid > div {
  min-width: 0;
  padding: 14px;
  border: 1px solid rgba(255, 255, 255, 0.075);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.035);
}

.meicStructureGrid span {
  display: block;
  color: rgba(244, 244, 244, 0.52);
  font-size: 0.7rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.meicStructureGrid strong {
  display: block;
  margin-top: 9px;
  color: #ffffff;
  font-size: 1.05rem;
  line-height: 1;
  font-weight: 900;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ================= STATES ================= */

.meicErrorState,
.meicEmptyState {
  margin-bottom: 18px;
  padding: 18px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.025);
  box-sizing: border-box;
}

.meicErrorState {
  border: 1px solid rgba(255, 100, 100, 0.32);
}

.meicEmptyState {
  border: 1px solid rgba(177, 136, 0, 0.28);
}

.meicErrorState strong {
  display: block;
  color: #ff6464;
  font-size: 0.95rem;
}

.meicEmptyState strong {
  display: block;
  color: #f4d06f;
  font-size: 0.95rem;
}

.meicErrorState span,
.meicEmptyState span {
  display: block;
  margin-top: 7px;
  color: rgba(244, 244, 244, 0.58);
  font-size: 0.86rem;
  line-height: 1.45;
}

/* ================= VALUE COLORS ================= */

.meicPositive {
  color: #55d17a !important;
}

.meicNegative {
  color: #ff6464 !important;
}

.meicNeutral {
  color: rgba(244, 244, 244, 0.75) !important;
}

/* ================= DISCLAIMER ================= */

.meicDisclaimer {
  margin-top: 18px;
  padding: 14px 16px;
  border: 1px solid rgba(255, 255, 255, 0.075);
  border-radius: 14px;
  color: rgba(244, 244, 244, 0.42);
  background: rgba(255, 255, 255, 0.025);
  font-size: 0.74rem;
  line-height: 1.45;
}

/* ================= RESPONSIVE ================= */

@media (max-width: 1180px) {
  .meicHero {
    grid-template-columns: 1fr;
  }

  .meicStatsGrid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .meicTwoColumnLayout {
    grid-template-columns: 1fr;
  }

  .meicStructureGrid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 860px) {
  .meicPage {
    padding: 16px;
  }

  .meicHeroContent,
  .meicSummaryCard,
  .meicStatCard,
  .meicPanel,
  .meicInsightCard,
  .meicTablePanel {
    border-radius: 16px;
  }

  .meicSummaryGrid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .meicPanelHeader {
    flex-direction: column;
  }
}

@media (max-width: 560px) {
  .meicStatsGrid,
  .meicSummaryGrid,
  .meicStructureGrid {
    grid-template-columns: 1fr;
  }

  .meicHeroContent,
  .meicSummaryCard,
  .meicStatCard,
  .meicPanel,
  .meicInsightCard,
  .meicTablePanel {
    padding: 16px;
  }

  .meicHeroContent h1 {
    font-size: 2.6rem;
  }

  .meicHistoryTable {
    min-width: 300px;
  }

  .meicHistoryTable th {
    font-size: 0.64rem;
    padding: 8px 6px;
  }

  .meicHistoryTable td {
    font-size: 0.76rem;
    padding: 9px 6px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Styles/MEICPage.css"],"names":[],"mappings":"AAAA,kDAAkD;;AAElD;EACE,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd;;WAES;EACT,sBAAsB;AACxB;;AAEA,yDAAyD;;AAEzD;;;;;;EAME,yCAAyC;EACzC,mBAAmB;EACnB;;WAES;EACT,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;;;;;;EAME,aAAa;AACf;;AAEA;;;;;EAKE,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA,6CAA6C;;AAE7C;EACE,aAAa;EACb,8DAA8D;EAC9D,SAAS;EACT,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mCAAmC;EACnC,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,qDAAqD;AACrD,qDAAqD;;AAErD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;EACd;;2BAEyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,2CAA2C;EAC3C;;;wBAGsB;AACxB;;AAEA;EACE,sCAAsC;EACtC;;2BAEyB;EACzB,2BAA2B;AAC7B;AACA,qDAAqD;;AAErD;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,4CAA4C;EAC5C,mBAAmB;EACnB,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,sDAAsD;;AAEtD;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,4CAA4C;EAC5C,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,2DAA2D;;AAE3D;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA,sDAAsD;;AAEtD;EACE,YAAY;EACZ,aAAa;EACb,4CAA4C;EAC5C,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,qDAAqD;;AAErD;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,wEAAwE;;AAExE;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,iBAAiB;EACjB,mDAAmD;EACnD,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uDAAuD;;AAEvD;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,4CAA4C;EAC5C,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,+CAA+C;;AAE/C;;EAEE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,qDAAqD;;AAErD;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,mDAAmD;;AAEnD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,4CAA4C;EAC5C,mBAAmB;EACnB,gCAAgC;EAChC,sCAAsC;EACtC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,mDAAmD;;AAEnD;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;;;;;IAME,mBAAmB;EACrB;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;;;IAGE,0BAA0B;EAC5B;;EAEA;;;;;;IAME,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;AACF","sourcesContent":["/* ================= MEIC PAGE ================= */\n\n.meicPage {\n  min-height: 100%;\n  padding: 22px;\n  color: #f4f4f4;\n  background:\n    radial-gradient(circle at top left, rgba(177, 136, 0, 0.12), transparent 34%),\n    #050505;\n  box-sizing: border-box;\n}\n\n/* ================= SHARED CARD BASE ================= */\n\n.meicHeroContent,\n.meicSummaryCard,\n.meicStatCard,\n.meicPanel,\n.meicInsightCard,\n.meicTablePanel {\n  border: 1px solid rgba(177, 136, 0, 0.28);\n  border-radius: 18px;\n  background:\n    linear-gradient(180deg, rgba(255, 255, 255, 0.035), rgba(255, 255, 255, 0.015)),\n    #0b0b0b;\n  box-shadow: 0 18px 42px rgba(0, 0, 0, 0.35);\n  box-sizing: border-box;\n}\n\n.meicHeroContent,\n.meicSummaryCard,\n.meicStatCard,\n.meicPanel,\n.meicInsightCard,\n.meicTablePanel {\n  padding: 20px;\n}\n\n.meicEyebrow,\n.meicSectionEyebrow,\n.meicStatLabel,\n.meicSummaryLabel,\n.meicHistoryTable th {\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n\n.meicEyebrow,\n.meicSectionEyebrow {\n  color: #d8b44c;\n  font-size: 0.72rem;\n}\n\n.meicStatLabel,\n.meicSummaryLabel {\n  color: rgba(244, 244, 244, 0.52);\n  font-size: 0.7rem;\n}\n\n/* ================= HERO ================= */\n\n.meicHero {\n  display: grid;\n  grid-template-columns: minmax(0, 1.35fr) minmax(420px, 0.85fr);\n  gap: 18px;\n  align-items: stretch;\n  margin-bottom: 18px;\n}\n\n.meicHeroContent,\n.meicSummaryCard {\n  height: 100%;\n  min-width: 0;\n}\n\n.meicHeroContent {\n  padding: 24px 28px;\n  position: relative;\n  overflow: hidden;\n}\n\n.meicEyebrow {\n  display: inline-flex;\n  width: fit-content;\n  letter-spacing: 0.11em;\n}\n\n.meicHeroContent h1 {\n  margin: 10px 0 0;\n  color: #ffffff;\n  font-size: clamp(2.4rem, 4vw, 4rem);\n  line-height: 0.95;\n  letter-spacing: 0.02em;\n}\n\n.meicHeroContent h2 {\n  margin: 8px 0 0;\n  color: #b18800;\n  font-size: clamp(1.2rem, 2vw, 1.7rem);\n  font-weight: 800;\n}\n\n.meicHeroContent p {\n  max-width: 900px;\n  margin: 14px 0 0;\n  color: rgba(244, 244, 244, 0.74);\n  font-size: 0.96rem;\n  line-height: 1.58;\n}\n\n/* ================= HERO ACTIONS ================= */\n/* ================= HERO ACTIONS ================= */\n\n.meicHeroActions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 18px;\n}\n\n.meicPrimaryButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: fit-content;\n  padding: 11px 15px;\n  border: 1px solid rgba(177, 136, 0, 0.52);\n  border-radius: 12px;\n  color: #f4d06f;\n  background:\n    linear-gradient(145deg, rgba(177, 136, 0, 0.18), rgba(255, 255, 255, 0.035)),\n    rgba(177, 136, 0, 0.08);\n  font-size: 0.82rem;\n  font-weight: 900;\n  text-decoration: none;\n  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.28);\n  transition:\n    background 160ms ease,\n    border-color 160ms ease,\n    transform 160ms ease;\n}\n\n.meicPrimaryButton:hover {\n  border-color: rgba(216, 180, 76, 0.78);\n  background:\n    linear-gradient(145deg, rgba(177, 136, 0, 0.26), rgba(255, 255, 255, 0.05)),\n    rgba(177, 136, 0, 0.12);\n  transform: translateY(-1px);\n}\n/* ================= SUMMARY CARD ================= */\n\n.meicSummaryCard {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.meicSummaryStatus {\n  margin: 8px 0 0;\n  color: #ffffff;\n  font-size: clamp(1.2rem, 2vw, 1.7rem);\n  line-height: 1.1;\n  font-weight: 800;\n}\n\n.meicSummaryCard p {\n  margin: 14px 0 0;\n  color: rgba(244, 244, 244, 0.68);\n  font-size: 0.9rem;\n  line-height: 1.55;\n}\n\n.meicSummaryGrid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n  margin-top: 18px;\n}\n\n.meicSummaryMetric {\n  min-width: 0;\n  padding: 14px;\n  border: 1px solid rgba(255, 255, 255, 0.075);\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.035);\n  box-sizing: border-box;\n}\n\n.meicSummaryMetric strong {\n  display: block;\n  margin-top: 9px;\n  color: #ffffff;\n  font-size: 1.25rem;\n  line-height: 1;\n  font-weight: 800;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.meicSummaryMetric small {\n  display: block;\n  margin-top: 8px;\n  color: rgba(244, 244, 244, 0.48);\n  font-size: 0.74rem;\n  line-height: 1.25;\n}\n\n/* ================= TOP KPI STRIP ================= */\n\n.meicStatsGrid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 12px;\n  margin-bottom: 18px;\n}\n\n.meicStatCard {\n  min-width: 0;\n  padding: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.075);\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.035);\n}\n\n.meicStatLabel {\n  display: block;\n}\n\n.meicStatValue {\n  display: block;\n  margin-top: 10px;\n  color: #ffffff;\n  font-size: 1.45rem;\n  line-height: 1;\n  font-weight: 800;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.meicStatSubtext {\n  display: block;\n  margin-top: 8px;\n  color: rgba(244, 244, 244, 0.48);\n  font-size: 0.75rem;\n  line-height: 1.25;\n}\n\n/* ================= TWO COLUMN CONTENT ================= */\n\n.meicTwoColumnLayout {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(360px, 0.72fr);\n  gap: 18px;\n  align-items: stretch;\n  margin-bottom: 18px;\n}\n\n.meicLeftColumn {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 12px;\n  min-width: 0;\n}\n\n.meicRightColumn {\n  min-width: 0;\n}\n\n/* ================= INSIGHT CARDS ================= */\n\n.meicInsightCard {\n  min-width: 0;\n  padding: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.075);\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.035);\n}\n\n.meicInsightCard h3 {\n  margin: 6px 0 0;\n  color: #ffffff;\n  font-size: 1.08rem;\n  line-height: 1.2;\n  letter-spacing: 0;\n}\n\n.meicInsightCard p {\n  margin: 10px 0 0;\n  color: rgba(244, 244, 244, 0.68);\n  font-size: 0.88rem;\n  line-height: 1.5;\n}\n\n/* ================= PANEL HEADER ================= */\n\n.meicPanel {\n  min-width: 0;\n  overflow: hidden;\n  margin-bottom: 18px;\n}\n\n.meicPanelHeader {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.meicPanelHeader h2,\n.meicPanelHeader h3 {\n  margin: 6px 0 0;\n  color: #ffffff;\n  font-size: 1.15rem;\n  line-height: 1.2;\n  letter-spacing: 0;\n}\n\n.meicPanelHeader p {\n  margin: 6px 0 0;\n  color: rgba(244, 244, 244, 0.58);\n  font-size: 0.84rem;\n  line-height: 1.4;\n}\n\n.meicPanelHeaderCompact {\n  margin-bottom: 12px;\n}\n\n.meicPanelHeaderCompact h2 {\n  margin: 5px 0 4px;\n  font-size: 1.05rem;\n  line-height: 1.2;\n}\n\n.meicPanelHeaderCompact p {\n  margin: 0;\n  max-width: 360px;\n  color: rgba(244, 244, 244, 0.58);\n  font-size: 0.78rem;\n  line-height: 1.35;\n}\n\n/* ================= RIGHT SIDE RECENT RESULTS TABLE ================= */\n\n.meicRecentSessionsPanel {\n  height: 100%;\n  min-width: 0;\n  padding: 16px;\n  overflow: hidden;\n}\n\n.meicTableWrap {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.meicHistoryTable {\n  width: 100%;\n  min-width: 320px;\n  border-collapse: collapse;\n  table-layout: fixed;\n}\n\n.meicHistoryTable th {\n  padding: 9px 8px;\n  color: rgba(244, 244, 244, 0.52);\n  font-size: 0.68rem;\n  text-align: left;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.meicHistoryTable td {\n  padding: 10px 8px;\n  color: rgba(244, 244, 244, 0.82);\n  font-size: 0.8rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.055);\n  vertical-align: middle;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.meicHistoryTable tbody tr:hover {\n  background: rgba(177, 136, 0, 0.055);\n}\n\n.meicHistoryTableCompact th,\n.meicHistoryTableCompact td {\n  width: 33.333%;\n}\n\n.meicHistoryTableCompact th:nth-child(2),\n.meicHistoryTableCompact th:nth-child(3),\n.meicHistoryTableCompact td:nth-child(2),\n.meicHistoryTableCompact td:nth-child(3) {\n  text-align: right;\n}\n\n.meicHistoryTableCompact tbody tr:last-child td {\n  border-bottom: none;\n}\n\n/* ================= STRUCTURE GRID ================= */\n\n.meicStructureGrid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.meicStructureGrid > div {\n  min-width: 0;\n  padding: 14px;\n  border: 1px solid rgba(255, 255, 255, 0.075);\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.035);\n}\n\n.meicStructureGrid span {\n  display: block;\n  color: rgba(244, 244, 244, 0.52);\n  font-size: 0.7rem;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n\n.meicStructureGrid strong {\n  display: block;\n  margin-top: 9px;\n  color: #ffffff;\n  font-size: 1.05rem;\n  line-height: 1;\n  font-weight: 900;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* ================= STATES ================= */\n\n.meicErrorState,\n.meicEmptyState {\n  margin-bottom: 18px;\n  padding: 18px;\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.025);\n  box-sizing: border-box;\n}\n\n.meicErrorState {\n  border: 1px solid rgba(255, 100, 100, 0.32);\n}\n\n.meicEmptyState {\n  border: 1px solid rgba(177, 136, 0, 0.28);\n}\n\n.meicErrorState strong {\n  display: block;\n  color: #ff6464;\n  font-size: 0.95rem;\n}\n\n.meicEmptyState strong {\n  display: block;\n  color: #f4d06f;\n  font-size: 0.95rem;\n}\n\n.meicErrorState span,\n.meicEmptyState span {\n  display: block;\n  margin-top: 7px;\n  color: rgba(244, 244, 244, 0.58);\n  font-size: 0.86rem;\n  line-height: 1.45;\n}\n\n/* ================= VALUE COLORS ================= */\n\n.meicPositive {\n  color: #55d17a !important;\n}\n\n.meicNegative {\n  color: #ff6464 !important;\n}\n\n.meicNeutral {\n  color: rgba(244, 244, 244, 0.75) !important;\n}\n\n/* ================= DISCLAIMER ================= */\n\n.meicDisclaimer {\n  margin-top: 18px;\n  padding: 14px 16px;\n  border: 1px solid rgba(255, 255, 255, 0.075);\n  border-radius: 14px;\n  color: rgba(244, 244, 244, 0.42);\n  background: rgba(255, 255, 255, 0.025);\n  font-size: 0.74rem;\n  line-height: 1.45;\n}\n\n/* ================= RESPONSIVE ================= */\n\n@media (max-width: 1180px) {\n  .meicHero {\n    grid-template-columns: 1fr;\n  }\n\n  .meicStatsGrid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .meicTwoColumnLayout {\n    grid-template-columns: 1fr;\n  }\n\n  .meicStructureGrid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 860px) {\n  .meicPage {\n    padding: 16px;\n  }\n\n  .meicHeroContent,\n  .meicSummaryCard,\n  .meicStatCard,\n  .meicPanel,\n  .meicInsightCard,\n  .meicTablePanel {\n    border-radius: 16px;\n  }\n\n  .meicSummaryGrid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .meicPanelHeader {\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 560px) {\n  .meicStatsGrid,\n  .meicSummaryGrid,\n  .meicStructureGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .meicHeroContent,\n  .meicSummaryCard,\n  .meicStatCard,\n  .meicPanel,\n  .meicInsightCard,\n  .meicTablePanel {\n    padding: 16px;\n  }\n\n  .meicHeroContent h1 {\n    font-size: 2.6rem;\n  }\n\n  .meicHistoryTable {\n    min-width: 300px;\n  }\n\n  .meicHistoryTable th {\n    font-size: 0.64rem;\n    padding: 8px 6px;\n  }\n\n  .meicHistoryTable td {\n    font-size: 0.76rem;\n    padding: 9px 6px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
